import React from "react";
import "../styles/Footer.css";
import truevoteText from "../assets/truevote-text.png";
import truevoteLogo from "../assets/TrueVoteLogo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <img src={truevoteText} alt="TRUEVOTE" className="footer-logo" />
          <p className="footer-copyright">
            © 2025 Factaroo. All Rights Reserved
          </p>
        </div>
        <div className="footer-right">
          <div className="footer-info">
            <img
              src={truevoteLogo}
              alt="Factaroo Logo"
              className="footer-icon"
            />
            <p className="footer-description">
              Factaroo makes it easy to check the facts, match your values, and
              vote smarter—no political spin, just data.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
